import {useFormik} from 'formik'
import {IFilterInvoiceForm, initFilterInvoiceForm} from '../core/_model'
import {useRittApp} from '../../../utils/contextProvider/RittAppProvider'
import {KTIcon} from '../../../../_metronic/helpers'
import SelectEntriesOptions from '../../../utils/components/table-content/SelectEntriesOptions'
import {perPageItemsOptions} from '../../../utils/components/table-content/TableContentHeader'
import FlatPickrDate from '../../../utils/components/FlatPickrDate'
import ReactSelectBox from '../../../utils/components/ReactSelectBox'
import OptimizedSelectBox from '../../../utils/components/OptimizedSelectBox'

type Props = {
  onFilter: (sendvalues: Partial<IFilterInvoiceForm>) => void
  handlePagePerItem: (size: number) => void
  size: number
}

const FilterInvoice = ({onFilter, handlePagePerItem, size}: Props) => {
  const {userInfo} = useRittApp()

  const formik = useFormik({
    initialValues: initFilterInvoiceForm,
    onSubmit: async (values) => {
      try {
        const {username, ...sendvalues} = values
        await onFilter(sendvalues)
      } catch (error) {
        console.log(error)
      }
    },
  })

  const onSelectUser = (id: number) => formik.setFieldValue('userId', id)

  const resetForm = () => {
    formik.resetForm()
    onFilter({userId: null, sdate: '', edate: ''})
  }

  return (
    <>
      <button
        type='button'
        className='btn btn-light-primary me-3 border border-1 border-gray-500'
        id='dropdownFilterButton'
        data-bs-toggle='dropdown'
        aria-expanded='false'
        data-bs-auto-close='outside'
      >
        <KTIcon iconName='filter' className='fs-2' />
        Filter
      </button>
      <div
        className='dropdown-menu menu menu-sub menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-300px w-md-350px py-4'
        aria-labelledby='dropdownFilterButton'
      >
        <div className='px-7 py-5'>
          <div className='fs-5 text-gray-900 fw-bolder'>Filter Options</div>
        </div>

        <div className='separator border-gray-200'></div>

        <div className='px-7 py-5' data-kt-user-table-filter='form'>
          <form onSubmit={formik.handleSubmit}>
            <div className='mb-10'>
              <label className='form-label fs-6 fw-bold'>Show Entries:</label>

              <SelectEntriesOptions
                options={perPageItemsOptions}
                handleSelect={handlePagePerItem}
                value={size.toString()}
              />
            </div>

            <div className='mb-4'>
              <label className='form-label fs-6 fw-bold'>
                <span className='required'>Username:</span>
              </label>

              <OptimizedSelectBox
                formik={formik}
                fieldValue='username'
                placeholder='Select user'
                setSelect={onSelectUser}
                options={userInfo}
              />
            </div>

            <div className='mb-4'>
              <label className='form-label fs-6 fw-bold'>
                <span className='required'>Start Time:</span>
              </label>

              <div id='sdate' className=''>
                <FlatPickrDate
                  placeholder='Select start time'
                  fieldName='sdate'
                  formik={formik}
                  container='sdate'
                />
              </div>
            </div>

            <div className='mb-4'>
              <label className='form-label fs-6 fw-bold'>
                <span className='required'>End Time:</span>
              </label>

              <div id='edate' className=''>
                <FlatPickrDate
                  placeholder='Select end time'
                  fieldName='edate'
                  formik={formik}
                  container='edate'
                />
              </div>
            </div>

            <div className='d-flex justify-content-end mt-6'>
              <button
                type='button'
                className='btn btn-light btn-active-light-primary fw-bold me-2 px-6'
                data-kt-menu-dismiss='true'
                data-kt-user-table-filter='reset'
                onClick={resetForm}
              >
                Reset
              </button>
              <button
                type='submit'
                className='btn btn-primary fw-bold px-6'
                data-kt-menu-dismiss='true'
                data-kt-user-table-filter='filter'
              >
                Apply
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default FilterInvoice
